const rotateDesktopDropdownArrow = () => {
	const dropdowns = document.querySelectorAll('.header__main-links__dropdown');

	if (dropdowns) {
		dropdowns.forEach(dropdown => {
			const toggle = dropdown.querySelector('.js-nav-dropdown-toggle');

			if (!toggle) {
				return;
			}

			const setExpanded = isOpen => {
				toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
			};

			dropdown.addEventListener('mouseenter', () => setExpanded(true));
			dropdown.addEventListener('mouseleave', () => setExpanded(false));
			dropdown.addEventListener('focusin', () => setExpanded(true));
			dropdown.addEventListener('focusout', event => {
				if (!dropdown.contains(event.relatedTarget)) {
					setExpanded(false);
				}
			});
		});
	}
};

// rotateDesktopDropdownArrow();
